import { render, staticRenderFns } from "./StartTimesField.vue?vue&type=template&id=987a967c&scoped=true"
import script from "./StartTimesField.vue?vue&type=script&lang=ts"
export * from "./StartTimesField.vue?vue&type=script&lang=ts"
import style0 from "./StartTimesField.vue?vue&type=style&index=0&id=987a967c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a967c",
  null
  
)

export default component.exports